module.exports = __webpack_public_path__ + "img/full-interworx-3.08e0cc09.jpg";